import { useQuery } from "@tanstack/react-query"

import { getLocalAiLeadConfig } from "@/api/admin-api"
import { useAuthGeneration } from "@/hooks/use-auth-generation"

/**
 * Tenant-wide Local AI Lead configuration. Shared by the settings form and the
 * management card (which reads the configured group attribute/scope group when
 * opening the add/edit dialogs). React Query dedupes the two callers by key.
 * The auth generation sits last so a session change refetches while the
 * `["admin", "local-ai-lead-config"]` prefix invalidations still match.
 */
export function useLocalAiLeadConfigQuery() {
  const authGeneration = useAuthGeneration()
  return useQuery({
    queryKey: ["admin", "local-ai-lead-config", authGeneration],
    queryFn: getLocalAiLeadConfig,
  })
}
